import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import { useTranslations } from 'next-intl';
import type { RewardsTierDefinition } from './Rewards.types';
import { RewardsBenefitRow } from './RewardsBenefitRow';
import styles from './RewardsTierCard.module.css';
interface RewardsTierCardProps {
  readonly tier: RewardsTierDefinition;
  readonly isCurrent: boolean;
  readonly rowCount: number;
  readonly discount?: number;
}
export function RewardsTierCard(t0) {
  const $ = _c(45);
  const {
    tier,
    isCurrent,
    rowCount,
    discount
  } = t0;
  const t = useTranslations("account");
  const resolvedDiscount = discount ?? tier.discount;
  const fillerCount = Math.max(rowCount - tier.benefits.length, 0);
  let t1;
  if ($[0] !== fillerCount || $[1] !== tier.id) {
    let t2;
    if ($[3] !== tier.id) {
      t2 = (_, index) => `${tier.id}-filler-${index}`;
      $[3] = tier.id;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = Array.from({
      length: fillerCount
    }, t2);
    $[0] = fillerCount;
    $[1] = tier.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const fillerKeys = t1;
  const t2 = isCurrent && styles.current;
  let t3;
  if ($[5] !== t2) {
    t3 = clsx(styles.card, t2);
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = isCurrent ? "true" : undefined;
  const t5 = !isCurrent && styles.currentBadgePlaceholder;
  let t6;
  if ($[7] !== t5) {
    t6 = clsx(styles.currentBadge, t5);
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = !isCurrent || undefined;
  const t8 = isCurrent ? "RewardsTierCurrentBadge" : undefined;
  let t9;
  if ($[9] !== t) {
    t9 = t("rewards_tier_current_badge");
    $[9] = t;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
    t10 = <p className={t6} aria-hidden={t7} data-test-id={t8}>{t9}</p>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t || $[17] !== tier.nameKey) {
    t11 = t(tier.nameKey);
    $[16] = t;
    $[17] = tier.nameKey;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <h3 className={styles.name}>{t11}</h3>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t || $[22] !== tier.criteriaKey) {
    t13 = t(tier.criteriaKey);
    $[21] = t;
    $[22] = tier.criteriaKey;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13) {
    t14 = <p className={styles.criteria}>{t13}</p>;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== t12 || $[27] !== t14) {
    t15 = <header className={styles.header}>{t12}{t14}</header>;
    $[26] = t12;
    $[27] = t14;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== resolvedDiscount || $[30] !== tier.benefits) {
    let t17;
    if ($[32] !== resolvedDiscount) {
      t17 = benefit => <RewardsBenefitRow key={benefit.id} benefit={benefit} discount={benefit.isDiscount ? resolvedDiscount : undefined} />;
      $[32] = resolvedDiscount;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    t16 = tier.benefits.map(t17);
    $[29] = resolvedDiscount;
    $[30] = tier.benefits;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[34] !== fillerKeys) {
    t17 = fillerKeys.map(_temp);
    $[34] = fillerKeys;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t16 || $[37] !== t17) {
    t18 = <ul className={styles.benefits}>{t16}{t17}</ul>;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t10 || $[40] !== t15 || $[41] !== t18 || $[42] !== t3 || $[43] !== t4) {
    t19 = <article className={t3} aria-current={t4} data-test-id="RewardsTierCard">{t10}{t15}{t18}</article>;
    $[39] = t10;
    $[40] = t15;
    $[41] = t18;
    $[42] = t3;
    $[43] = t4;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
}
function _temp(fillerKey) {
  return <RewardsBenefitRow key={fillerKey} />;
}